// @ts-nocheck
import React from 'react';
import { MdOutlineDevices } from 'react-icons/md';
import { getLabelIcon, getSectionIcon } from '@/components/atoms/IconMap';
import { SectionCard } from '@/components/organism/Cards/SectionCard';
import { StatCell } from '@/components/organism/Cards/StatCell';
import { getDateTime } from '@/utils/dateTime';
import type { IDeviceProps } from '@/pages/Device/device.interface';
import { ORGANISM_PROPS } from '@/constant/global/global.constant';
import { APP_BORDER } from '@/constant/theme/colors.constant';
import { tid } from '@/utils/testId';
import { DEVICE_TEST_IDS as TID } from '@/constant/testIds/device.testIds';

/* ── Main panel ─────────────────────────────────────────────────────────── */
interface DeviceExpandedPanelProps {
  row: IDeviceProps;
}

export const DeviceExpandedPanel = ({ row }: DeviceExpandedPanelProps) => {
  return (
    <div
      data-testid={tid(TID.EXPANDED_PANEL)}
      className="px-2 py-3 space-y-3"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        {/* ── Internal UUIDs ───────────────────────────────────────────── */}
        <SectionCard
          testId={tid(TID.EXPANDED_UUIDS)}
          title={ORGANISM_PROPS.DEVICE_EXPANDED.SECTION_UUIDS}
          icon={getSectionIcon(ORGANISM_PROPS.DEVICE_EXPANDED.SECTION_UUIDS)}
          compact
          bodyClassName=""
        >
          <div className={`divide-y ${APP_BORDER.divideSoft}`}>
            <StatCell
              label={ORGANISM_PROPS.DEVICE_EXPANDED.LABEL_DEVICE_UUID}
              labelIcon={getLabelIcon(
                ORGANISM_PROPS.DEVICE_EXPANDED.LABEL_DEVICE_UUID,
              )}
              value={row?.deviceId}
              mono
            />
            <StatCell
              label={ORGANISM_PROPS.DEVICE_EXPANDED.LABEL_OPERATOR_UUID}
              labelIcon={getLabelIcon(
                ORGANISM_PROPS.DEVICE_EXPANDED.LABEL_OPERATOR_UUID,
              )}
              value={row?.operatorId}
              mono
            />
            <StatCell
              label={ORGANISM_PROPS.DEVICE_EXPANDED.LABEL_MARKET_UUID}
              labelIcon={getLabelIcon(
                ORGANISM_PROPS.DEVICE_EXPANDED.LABEL_MARKET_UUID,
              )}
              value={row?.marketId}
              mono
            />
          </div>
        </SectionCard>

        {/* ── Device Details ───────────────────────────────────────────── */}
        <SectionCard
          testId={tid(TID.EXPANDED_DETAILS)}
          title={ORGANISM_PROPS.DEVICE_EXPANDED.SECTION_DETAILS}
          icon={<MdOutlineDevices className="h-3.5 w-3.5" />}
          compact
          bodyClassName=""
        >
          <div
            className={`grid grid-cols-1 sm:grid-cols-2 divide-y sm:divide-x ${APP_BORDER.divideSoft}`}
          >
            <StatCell
              label={ORGANISM_PROPS.DEVICE_EXPANDED.LABEL_NAME}
              labelIcon={getLabelIcon(
                ORGANISM_PROPS.DEVICE_EXPANDED.LABEL_NAME,
              )}
              value={row?.name}
            />
            <StatCell
              label={ORGANISM_PROPS.DEVICE_EXPANDED.LABEL_MODEL}
              labelIcon={getLabelIcon(
                ORGANISM_PROPS.DEVICE_EXPANDED.LABEL_MODEL,
              )}
              value={row?.model}
            />
            <StatCell
              label={ORGANISM_PROPS.DEVICE_EXPANDED.LABEL_LOCATION}
              labelIcon={getLabelIcon(
                ORGANISM_PROPS.DEVICE_EXPANDED.LABEL_LOCATION,
              )}
              value={row?.location}
            />
            <StatCell
              label={ORGANISM_PROPS.DEVICE_EXPANDED.LABEL_LAST_TRANSACTION}
              labelIcon={getLabelIcon(
                ORGANISM_PROPS.DEVICE_EXPANDED.LABEL_LAST_TRANSACTION,
              )}
              value={
                row?.lastTransactionDtm
                  ? getDateTime(row.lastTransactionDtm)
                  : undefined
              }
            />
            <StatCell
              label={ORGANISM_PROPS.DEVICE_EXPANDED.LABEL_CATALOG_DTM}
              labelIcon={getLabelIcon(
                ORGANISM_PROPS.DEVICE_EXPANDED.LABEL_CATALOG_DTM,
              )}
              value={
                row?.catalogDtm ? getDateTime(row.catalogDtm) : undefined
              }
            />
          </div>
        </SectionCard>
      </div>
    </div>
  );
};

export default DeviceExpandedPanel;

